import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';

export const Content = props => (
    <article className="free-mobile-fitting-light-box">
        <span
            className="free-mobile-fitting-light-box__close"
            onClick={props.onClose}
        />
        <header className="free-mobile-fitting-light-box__header">
            <Translation
                tagName="h2"
                className="free-mobile-fitting-light-box__headline"
                translationKey="free-mobile-fitting-lightbox-headline"
            />
          
        </header>
        <main className="free-mobile-fitting-light-box__content">
            <img className="free-mobile-fitting-light-box__image"
                src={TYROOLA.globals.staticImagesUrl + "images/svg/delivery-truck-with-tyres.svg"}/>

        </main>
        <footer className="free-mobile-fitting-light-box__footer">
            <Translation
                tagName="h2"
                className="free-mobile-fitting-light-box__text-headline"
                translationKey="free-mobile-fitting-lightbox-how-it-works"
            />

            <ol>
                <Translation
                    tagName="li"
                    translationKey="free-mobile-fitting-lightbox-pre-step"
                />

                <Translation
                    tagName="li"
                    translationKey="free-mobile-fitting-lightbox-step-1"
                />

                <Translation
                    tagName="li"
                    translationKey="free-mobile-fitting-lightbox-step-2"
                />

                <Translation
                    tagName="li"
                    translationKey="free-mobile-fitting-lightbox-step-3"
                />
            </ol>
            <Translation
                tagName="button"
                className="free-mobile-fitting-light-box__primary-cta"
                onClick={props.onClose}
                translationKey="free-mobile-fitting-lightbox-button"
            />
        </footer>
    </article>
);

Content.propTypes = {
    staticUrl: PropTypes.string.isRequired,
    baseUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};
